import { useState, useEffect, useRef } from 'react';
import { starteKonfetti } from '../../utils/konfetti';
import apiService from '../../services/apiService';
import { useI18n } from '../../utils/i18n';

// #471 (Scheibe 1 aus #313): Hinweis bei Login (Einmal-Overlay, release_notes).
// Code unveraendert aus Dashboard.js uebernommen, Muster aus #312: Den Zustand
// haelt der Hook, und das Dashboard ruft ihn ganz oben auf. Die Komponente
// rendert nur.
//
// Warum der Hook nicht in die Overlay-Komponente darf: Das Dashboard hat ein
// fruehes `return` fuer Laden und Fehler, und "Erneut versuchen" schaltet
// zurueck auf Laden. Eine Komponente unterhalb davon wuerde dabei entfernt --
// der Hinweis wuerde danach erneut abgerufen und, weil er nach dem ersten
// Abruf schon quittiert sein kann, im Zweifel gar nicht mehr gezeigt.
// Dashboard.scheiben.test.js haelt das fest.
export function useReleaseNote() {
  const [releaseNote, setReleaseNote] = useState(null);
  const [showReleaseNote, setShowReleaseNote] = useState(false);

  useEffect(() => {
    const loadReleaseNote = async () => {
      try {
        const resp = await apiService.getReleaseNote();
        if (resp && resp.shouldShow && resp.note) {
          setReleaseNote(resp.note);
          setShowReleaseNote(true);
        }
      } catch (error) {
        console.error('Load release note error:', error);
      }
    };
    loadReleaseNote();
  }, []);

  const handleCloseReleaseNote = async () => {
    setShowReleaseNote(false);
    try {
      await apiService.ackReleaseNote();
    } catch (error) {
      console.error('Ack release note error:', error);
    }
  };

  return { releaseNote, showReleaseNote, handleCloseReleaseNote };
}

export default function ReleaseNoteOverlay({ releaseNote, onClose: handleCloseReleaseNote }) {
  const { t } = useI18n();
  // v3.0.1: Konfetti, wenn der Hinweis erscheint; schliessen beendet es.
  // #608: aus den unteren Ecken des Dialogs
  const dialog = useRef(null);
  useEffect(() => starteKonfetti({ ziel: dialog.current }), []);
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'var(--color-backdrop-60)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) handleCloseReleaseNote();
      }}
    >
      <div
        ref={dialog}
        style={{
          backgroundColor: 'var(--color-surface)',
          borderRadius: 12,
          maxWidth: 600,
          width: '100%',
          maxHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 20px 60px var(--color-shadow-30)'
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '16px 20px',
            borderBottom: '1px solid var(--color-border-light)'
          }}
        >
          <h2 style={{ margin: 0, fontSize: 20, fontWeight: 600, color: 'var(--color-text)' }}>
            {releaseNote.title || t('dashboard.releaseNote.defaultTitle', 'Neue Funktionen & Änderungen')}
          </h2>
          <button
            onClick={handleCloseReleaseNote}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 4,
              borderRadius: 4,
              color: 'var(--color-text-muted)',
              lineHeight: 1
            }}
            aria-label={t('common.close', 'Schließen')}
            title={t('common.close', 'Schließen')}
          >
            <span style={{ fontSize: 24, fontWeight: 300 }}>×</span>
          </button>
        </div>
        <div style={{ padding: '20px', overflowY: 'auto', flex: 1 }}>
          <div style={{ whiteSpace: 'pre-wrap', lineHeight: 1.6, color: 'var(--color-text-emphasis)' }}>
            {releaseNote.content}
          </div>
        </div>
        <div
          style={{
            padding: '16px 20px',
            borderTop: '1px solid var(--color-border-light)',
            display: 'flex',
            justifyContent: 'flex-end'
          }}
        >
          <button
            onClick={handleCloseReleaseNote}
            className="btn btn-primary"
            style={{ minWidth: 100 }}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
